import { useSplitTests } from '@api/lendingAPI/lapiHooks';
import { differenceInDays } from 'date-fns';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { DocUploadBanner } from './DocUploadBanner/DocUploadBanner';
import { HomeScreenBanner } from './HomeScreenBanner/HomeScreenBanner';
import {
    GetDocumentUploadResponse,
    fetchGetDocumentUpload
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

export const InformationBanners = () => {
    const stateKey = useStateKey();

    const {
        data: uploadedDocs,
        isLoading,
        isError
    } = useQuery<GetDocumentUploadResponse>({
        queryKey: ['documents', stateKey],
        queryFn: () => fetchGetDocumentUpload({ stateKey }),
        enabled: Boolean(stateKey)
    });

    const isInHomescreenBannerSplitTest = useSplitTests('homescreen_banner');
    const isInDocUploadBannerSplitTest = useSplitTests('doc_upload_banner');

    const lastUploadedBankStatement = uploadedDocs?.data?.find(
        (document) => document.type === 'bank_statement'
    );
    const hasUploadedBankStatementsInLastThirtyDays =
        differenceInDays(
            new Date().toISOString().split('T')[0],
            // @ts-expect-error
            lastUploadedBankStatement?.attributes?.uploaded_at.split('T')[0]
        ) < 30;

    const showDocUploadBanner =
        isInDocUploadBannerSplitTest &&
        !hasUploadedBankStatementsInLastThirtyDays;

    if (isLoading || isError) return null;

    if (showDocUploadBanner) return <DocUploadBanner />;
    if (isInHomescreenBannerSplitTest) return <HomeScreenBanner />;
    return null;
};
